import React from "react";
import { withPrefix } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";
import CommentsSide from "./commentsSide";

import "./currentConversation.scss";

const CurrentConversation = (props: ReferenciaContenido) => {
  const {
    tituloGeneral,
    referenciaPlantillaContenido,
    redireccionBoton,
  } = props;

  return (
    <section className="o-current-conversation">
      <h2 className="o-current-conversation__title">{tituloGeneral}</h2>
      <div className="o-current-conversation__content">
        <a
          className="o-current-conversation__content__left"
          href={
            redireccionBoton.indexOf("http") !== -1
              ? redireccionBoton
              : withPrefix(redireccionBoton)
          }
          target={redireccionBoton.indexOf("http") !== -1 ? "_blank" : "_self"}
          rel={findRel(redireccionBoton)}
        >
          <img
            className="o-current-conversation__content__left__image"
            src={referenciaPlantillaContenido[0].imagenPrincipal[0].file.url}
            alt={
              referenciaPlantillaContenido[0].imagenPrincipal[0].title
                ? formatImageAlt(
                    referenciaPlantillaContenido[0].imagenPrincipal[0].title
                  )
                : "Imagen conversación"
            }
          />
          <div className="o-current-conversation__content__left__texts">
            <h3 className="o-current-conversation__content__left__texts__name">
              {referenciaPlantillaContenido[0].tituloBanner}
            </h3>
            <p className="o-current-conversation__content__left__texts__desc">
              {
                referenciaPlantillaContenido[0].descripcion.json.content[0]
                  .content[0].value
              }
            </p>
            <div className="o-current-conversation__content__left__texts__author">
              <img
                className="o-current-conversation__content__left__texts__author__photo"
                src={
                  referenciaPlantillaContenido[0].redireccionTabs[0].imagenLibro
                    .file.url
                }
                alt={
                  referenciaPlantillaContenido[0].redireccionTabs[0].imagenLibro
                    .title
                    ? formatImageAlt(
                        referenciaPlantillaContenido[0].redireccionTabs[0]
                          .imagenLibro.title
                      )
                    : "Imagen conversación"
                }
              />
              <p className="o-current-conversation__content__left__texts__author__name">
                {referenciaPlantillaContenido[0].redireccionTabs[0].nombreTab}
              </p>
            </div>
          </div>
        </a>
        <div className="o-current-conversation__content__right">
          <CommentsSide
            sectionTitle={referenciaPlantillaContenido[0].tituloBanner}
            title={props.descripcion}
            conversationId={props.autoresArticulo[0]}
            textLogin={props.tituloBoton}
          />
        </div>
      </div>
    </section>
  );
};

export default CurrentConversation;
